import { useQuery } from "react-query";
import { getFilteredOfficeAppliance } from "../api/officeApplianceService";

export const useFilteredOfficeAppliance = ({ filterInput }) => {
  return useQuery(
    ["FilteredOfficeAppliances", filterInput],
    getFilteredOfficeAppliance,
    {
      enabled: false,
    }
  );
};
